import { Fragment } from "react";
import PropTypes from "prop-types";

const FixedSteps = (props) => {
  const { steps, defaultStep } = props;
  const displaySteps = [...steps].reverse();
  return (
    <div className="fixed-step">
      <div className="fixed-step--label">
        Lightness: 0, {""}
        {displaySteps.map((value, index, array) =>
          index === array.length - 1 ? (
            `${value}`
          ) : defaultStep === index ? (
            <Fragment key={index}>
              <strong>{value}</strong>,{" "}
            </Fragment>
          ) : (
            `${value}, `
          ),
        )}
        , 100
      </div>
    </div>
  );
};

FixedSteps.propTypes = {
  trackStyle: PropTypes.object,
  steps: PropTypes.array,
  maxValue: PropTypes.number,
  defaultStep: PropTypes.number,
};

export default FixedSteps;
